export default "__VITE_ASSET__DmAQRsjK__"